import React, { Component } from "react";
import MainLogin from "../../config/mainLogin";
import ReCAPTCHA from 'react-google-recaptcha';
import swal from "sweetalert";
import { API_MHS } from "../../services/key/api";
import { KEY_MHS } from "../../services/key/api_key";
import GoogleTranslateButton from "../admin-component/Translate";

export default class Login extends Component {
  state = {
    nim_mahasiswa: '',
    pass_mahasiswa: '',
    captcha: '',
  }
  captchaRes = (value) => {
    this.setState({
      captcha: value
    })
  }
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  handleLogin = async (event) => {
    event.preventDefault()
    document.getElementById('btnLogin').disabled = true
    document.getElementById('btnLogin').innerHTML = 'wait&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i>'
    if (this.state.captcha != "") {
      await API_MHS.post('login/simaka/mobile' + KEY_MHS, this.state)
        .then(Response => {
          if (Response.data && Response.data[0] && Response.data[0].token) {
            localStorage.setItem('jwt_token', Response.data[0].token);
            localStorage.setItem('token_type', Response.data[0].token_type || 'Bearer');
            localStorage.setItem('user_role', Response.data[0].role || 'mahasiswa');
            localStorage.setItem('user_id', Response.data[0].nim || Response.data[0].id);
          }
          this.setState({
            filedatas: Response.data[0].filedatas,
            icmb: Response.data[0].id,
            nim: Response.data[0].nim,
            res: Response.status
          })
        })
      this.ceklogin();
    } else {
      swal({
        title: "Silahkan isi captcha terlebih dahulu!",
        text: "menutup jendela...",
        icon: "warning",
        timer: 3000,
        buttons: false,
      });
      document.getElementById('btnLogin').disabled = false
      document.getElementById('btnLogin').innerHTML = "Login"
    }
  }
  ceklogin() {
    if (this.state.res == 200) {
      const loginStatus = this.state.filedatas
      if (loginStatus == 1) {
        this.props.history.push({
          pathname: '/loading',
          state: { icmb: this.state.icmb }
        })
      }
      else if (loginStatus == '0a' || loginStatus == '0b') {
        swal({
          icon: "info",
          title: "Gagal Login!",
          text: "Silahkan cek kembali username dan password anda!"
        });
        document.getElementById('btnLogin').disabled = false
        document.getElementById('btnLogin').innerHTML = "Login"
      }
      else {
        swal({
          icon: "info",
          title: "Gagal Login!",
          text: "Silahkan cek kembali username dan password anda!"
        });
        document.getElementById('btnLogin').disabled = false
        document.getElementById('btnLogin').innerHTML = "Login"
      }
    } else if (this.state.res == 500) {
      swal({
        icon: "info",
        title: "Gagal Login!",
        text: "Silahkan login kembali!"
      });
      document.getElementById('btnLogin').disabled = false
      document.getElementById('btnLogin').innerHTML = "Login"
    }
  }

  componentDidMount = () => {
    if (localStorage.getItem('isLogin')) {
      window.location.replace('/home')
    } else {
      setTimeout(function () {
        document.getElementById("darkLoader").classList.add("sembunyi")
        document.getElementById("loginArea").classList.remove("sembunyi")
      }, 2000)
    }
  };

  render() {
    return (
      <div>
        {
          localStorage.getItem('isLogin') ?
            null :
            <>
              <MainLogin />
              <div id="loginArea" className="sembunyi">
                <div className="content" id="animasi">
                  <div className="container centerVer">
                    <div className="row">
                      <div className="col-md-6 order-md-2 mb-3" id="gbrLog">
                        <img
                          src="loginAset/images/gambar.svg"
                          alt="Image"
                          className="img-fluid"
                          style={{ width: '100%', marginTop: '2%' }}
                          id="gbrku"
                        />
                      </div>
                      <div className="col-md-6 contents">
                        <div className="row justify-content-center">
                          <div className="col-md-8">
                            <img
                              src="adminAset/images/logo.png"
                              style={{ width: '48%', marginBottom: '6%' }}
                            />
                            <div className="mb-4">
                              <h3 style={{ lineHeight: '1.2' }}>
                                Sistem informasi orang tua akademik <strong>Institut Asia</strong>
                              </h3>
                              <p className="mb-2 captionP">
                                Silahkan masuk untuk mengakses aplikasi.
                              </p>
                            </div>
                            <form onSubmit={this.handleLogin}>
                              <div className="form-group first" style={{ marginTop: '30px' }}>
                                <label htmlFor="username">Username</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  onChange={this.handleChange}
                                  name="nim_mahasiswa"
                                  id="nim_mahasiswa"
                                  style={{ fontSize: '16px' }}
                                />
                              </div>
                              <div
                                className="form-group last mb-4"
                                style={{ marginTop: "35px" }}
                              >
                                <label htmlFor="password">Password</label>
                                <input
                                  type="password"
                                  className="form-control"
                                  id="pass_mahasiswa"
                                  onChange={this.handleChange}
                                  name="pass_mahasiswa"
                                  style={{ fontSize: '16px', marginBottom: '-10px' }}
                                />
                              </div>

                              <ReCAPTCHA
                                sitekey="6Lfv8KorAAAAAMJDkKiR9JOMEzc48dXjHCuooyqk"
                                onChange={this.captchaRes}
                              />

                              <button
                                style={{ marginTop: "15px" }}
                                type="submit"
                                data-callback='onSubmit'
                                className="btn text-white btn-block btn-primary2"
                                id="btnLogin"
                              >
                                Login
                              </button>
                            </form>
                            <br />
                            {/* <GoogleTranslateButton /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <svg id="darkLoader" className="" width="100%" viewBox="0 0 100 100" style={{ backgroundColor: 'white' }}>
                <circle className="circle" id="circle-1" cx={50} cy={50} r={1000} fill="rgba(167, 206, 232, .25)" />
                <circle className="circle" id="circle-2" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
                <circle className="circle" id="circle-3" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
              </svg>
            </>
        }
      </div>
    );
  }
}